import { readAssignedCoupons } from '@/data/Content/AccountCoupons';
import { DPP_HCL_ID_PATTERN, DPP_MAX_COUPONS_PER_ORDER } from '@/data/dpp/constants';
import { transactionsAssignedCoupon } from 'integration/generated/transactions';
import type { RequestParams } from 'integration/generated/transactions/http-client';

export const captureDppOrderCouponIds = async (
	storeId: string,
	params: RequestParams = {}
): Promise<string[]> => {
	try {
		const assigned = await transactionsAssignedCoupon(true).cartSelfAssignedCouponDetail(
			storeId,
			{},
			params
		);
		const couponIds = readAssignedCoupons(assigned)
			.map(({ couponId }) => couponId)
			.filter((couponId): couponId is string => !!couponId && DPP_HCL_ID_PATTERN.test(couponId));
		return Array.from(new Set(couponIds)).slice(0, DPP_MAX_COUPONS_PER_ORDER);
	} catch {
		return [];
	}
};
